import { DateTime } from "luxon";
import { stateToTimezone } from "./stateToTimezone";

export const convertToLocalTime = (date: string, time: string, stateCode: string): DateTime => {
	const venueZone = stateToTimezone[stateCode?.toUpperCase()] ?? "America/New_York";
	const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const isTimeValid = !!time?.trim() && time.trim()?.toUpperCase() !== "TBA";
	const datePart = date.split("T")[0];

	const venueDateTime = isTimeValid
		? DateTime.fromFormat(`${datePart} ${time.trim()}`, "yyyy-MM-dd h:mm a", { zone: venueZone })
		: DateTime.fromISO(datePart, { zone: venueZone });

	return venueDateTime.isValid
		? venueDateTime.setZone(browserZone)
		: DateTime.fromISO(date, { zone: "utc" }).setZone(browserZone);
};
